import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { useLocation } from 'react-router';
import { useIntl } from "react-intl";
import PropTypes from 'prop-types';
import { makeStyles, Container, Typography, Box, Button } from '@material-ui/core';

import { getAlternateLogo } from "../../utils";
import { getI18n } from "../../utils/intl";
import Branding from '../../components/Header/Branding';
import { getThemes } from '../../reducers/portalConfig';

import styles from "./styles"

const useStyles = makeStyles(styles);

export const CheckEmail = ({ logo, alternateLogo }) => {
  const intl = getI18n(useIntl());
  const classes = useStyles();

  const { search } = useLocation();
  const isRegistration = new URLSearchParams(search).get('registration-success') === 'true';

  const handleClick = () => {
    window.location.href = "/admin/homeRedirect"
  }

  return <Container className={classes.root}>
    <Box className={classes.content}>
      <Box className={classes.header}>
        {logo ? <Branding logo={logo} /> : <Typography variant='h1' className={classes.alternateLogo}>
          {alternateLogo}
        </Typography>}
        <Typography variant='h1' className={classes.title}
          data-apim-test='check-email-title'
        >
          {intl.getI18nMessage("label.checkemail.title")}
        </Typography>
      </Box>

      <Typography variant='subtitle1'
        data-apim-test='check-email-description'
      >
        {intl.getI18nMessage(isRegistration ? "label.checkemail.registration.description" : "label.checkemail.description")}
      </Typography>

      <Button variant='text' data-apim-test='check-email-return-home'
        color='secondary' className={classes.homeButton} onClick={handleClick}
      >
        {intl.getI18nMessage("label.checkemail.return.homepage")}
      </Button>
    </Box>
  </Container>
}

const mapStateToProps = (state) => {
  const { logo, siteTitle } = getThemes(state);

  return {
    logo,
    alternateLogo: getAlternateLogo(siteTitle),
  };
};

CheckEmail.propTypes = {
  logo: PropTypes.string,
  alternateLogo: PropTypes.string,
};

export default compose(
  connect(mapStateToProps),
)(CheckEmail);